import { wioApiAxiosClient } from 'libs/axios';
import { risks } from '../constants/urls';
import type { Risk } from './interfaces';

/** Risk profile catalog (colors + count) from wio.api, scoped by the token's company. */
export const getRisks = async (): Promise<Risk[]> => {
  const { data } = await wioApiAxiosClient.get<Risk[]>(risks);
  return data;
};
